import { useEffect } from 'react';
import { Header, ContentContainer, Card, CardContent } from 'prosci-ui';
import { usePageContext } from '@/contexts/page-context';
import { PromptsTab } from '../kaiya-config/prompts-tab';

export function KaiyaPromptsPage() {
  const { setShowPageHeader } = usePageContext();

  useEffect(() => {
    setShowPageHeader(false);
    return () => setShowPageHeader(true);
  }, [setShowPageHeader]);

  return (
    <>
      <Header
        title="Prompts"
        description="Manage system, follow-up, and tech prompts for Kaiya"
      />
      <ContentContainer>
        <Card>
          <CardContent className="p-6">
            <PromptsTab />
          </CardContent>
        </Card>
      </ContentContainer>
    </>
  );
}
